module.exports = __webpack_public_path__ + "img/9788958286752.768dd7f4.jpg";